var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/error/guards.ts
function isError(value) {
  if (typeof Error === "object" && Error !== null && "isError" in Error) {
    return Error.isError(value);
  }
  return value !== null && typeof value === "object" && "name" in value && "mess\
age" in value && (typeof value.name === "string" || typeof value.message === "st\
ring");
}
__name(isError, "isError");
function isErrorOfType(value, errorType) {
  return isError(value) && value instanceof errorType;
}
__name(isErrorOfType, "isErrorOfType");
function getErrorMessage(error) {
  if (isError(error)) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return String(error);
}
__name(getErrorMessage, "getErrorMessage");
function getErrorStack(error) {
  if (isError(error) && error.stack) {
    return error.stack;
  }
  return "";
}
__name(getErrorStack, "getErrorStack");
function getErrorInfo(error) {
  if (isError(error)) {
    return {
      message: error.message,
      name: error.name,
      stack: error.stack,
      code: "code" in error ? String(error.code) : void 0,
      cause: "cause" in error ? error.cause : void 0
    };
  }
  return {
    message: String(error)
  };
}
__name(getErrorInfo, "getErrorInfo");
export {
  getErrorInfo,
  getErrorMessage,
  getErrorStack,
  isError,
  isErrorOfType
};
